<script>
    import { navigate } from 'svelte-routing';
    import {
        triggerValidation,
        goBack,
        totalPayment,
        store,
        shouldVerifyPromotions,
        isDisabled,
    } from '../../Store.svelte';
    import { createEventDispatcher, onMount } from 'svelte';
    import CartInformation from './CartInformation.svelte';

    export let isModalVisible;
    export let isMobile;

    let total;
    let complementsIncludes;
    let container;
    let step;
    const isSky = $store.requestedServices.isSky;

    const dispatch = createEventDispatcher();

    $: {
        total = $totalPayment;
        step = $store.settings.location.step;
        complementsIncludes = $store.requestedServices.channelExtras.length;
    }

    onMount(() => {
        container = document.getElementById('container');
    });

    function verify() {
        dispatch('verifyPromotions');
    }

    function toggleModal() {
        isModalVisible = !isModalVisible;
        if (isModalVisible) {
            scrollToModal();
            if (container) container.style.overflow = 'hidden';
        } else {
            if (container) container.style.overflow = 'auto';
        }
    }

    function scrollToModal() {
        const modal = document.querySelector('.scroll-content');
        if (modal) {
            modal.scrollIntoView({ behavior: 'smooth' });
        }
    }

    function formatNumber(num) {
        var parts = (+num).toFixed(2).split('.');
        var finalNum =
            parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
            (+parts[1] ? '.' + parts[1] : '');
        num = finalNum;
        return num;
    }

    function backRoute() {
        goBack.set(true);
    }

    function nextRoute() {
        triggerValidation.set(true);
    }

    function secondStep() {
        $store.requestedServices.total = total;
        $store.requestedServices.totalOriginal = total;
        $store.requestedServices.izzimovil.length > 0
            ? navigate('/compra/entrega', { replace: false })
            : navigate('/compra/datos', { replace: false });
    }

    function finishStep() {
        navigate('/comparador', { replace: false });
    }
</script>

<section class="container-promotions">
    {#if step < 5}
        <article
            class="mobile-promotions"
            on:keydown={toggleModal}
            on:click={toggleModal}
        >
            <div class="progress-bar">
                <hr class="progress-indicator" />
            </div>

            {#if !isModalVisible}
                <section class="selected-package">
                    <section class="info-package">
                        <p class="fw-semibold text-fs-13">Paquete elegido</p>
                        <p class="text-fs-13">
                            {$store.requestedServices.product.title}
                        </p>
                        {#if complementsIncludes > 0}
                            <p class="text-fs-13 fw-semibold aqua-text">
                                {complementsIncludes} complemento{complementsIncludes !=
                                1
                                    ? 's'
                                    : ''}
                            </p>
                        {/if}
                    </section>
                </section>
                <section class="total-package">
                    <section>
                        <p class="fw-semibold text-fs-13">
                            Precio total a pagar
                        </p>
                        <p class="h2 text-fs-26 fw-semibold primary-text">
                            ${formatNumber(total)}
                        </p>
                    </section>
                </section>
            {/if}

            <div class={!isModalVisible ? 'scroll-content' : 'visible'}>
                <CartInformation {isMobile} />
            </div>
        </article>
    {/if}
    <div class="navigation-buttons">
        {#if step != 1 && step != 7}
            <button class="back-button" on:click={backRoute}>
                <svg class="icon" aria-hidden="true">
                    <use
                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-left"
                    />
                </svg>
                atrás
            </button>
            <button
                class="continue-button {!$isDisabled
                    ? ' pure__button--disabled'
                    : 'pure__button--base'}"
                disabled={!$isDisabled}
                on:click={nextRoute}>Continuar</button
            >
        {:else if step === 7}
            <button
                type="button"
                on:click={finishStep}
                class="pure__button continue-button pure__button--expand m-b-15"
            >
                volver al inicio
            </button>
        {:else if !$shouldVerifyPromotions}
            <button
                type="button"
                on:click={secondStep}
                class="pure__button {isSky
                    ? 'pure__button--blue-dark'
                    : 'continue-button'} pure__button--expand m-b-15"
            >
                Continuar
            </button>
        {:else}
            <button
                type="button"
                on:click={verify}
                class="pure__button {isSky
                    ? 'pure__button--blue-dark'
                    : 'pure__button--aqua'} pure__button--expand m-b-15"
            >
                Verificar promociones
            </button>
        {/if}
    </div>
</section>
